import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.userIsAuthenticated
      .then(value => {
        if (!value) {
          this.router.navigate(['/auth'], {
            state: { previous: route.path }
          });
        }
        return value != null;
      })
      .catch(() => {
        this.router.navigate(['/auth'], {
          state: { previous: route.path }
        });
        return true;
      });
  }
}
